import { getItemPrototypeFeatureDefault } from "~/common/defaults/item-prototype-feature.default";
import { getKindDefault } from "~/common/defaults/kind.default";
import { COMMON_STATUS } from "~/common/interfaces/common-status.enum";
import type {
	ItemPrototype,
	ItemPrototypeAdapted
} from "~/common/interfaces/entities/item-prototype.interface";

export const getItemPrototypeDefault = (): ItemPrototype => ({
	id: 0,
	isActive: false,
	createdAt: new Date().toLocaleString(),
	updatedAt: new Date().toLocaleString(),
	feature: getItemPrototypeFeatureDefault(),
	translations: [],
	kind: getKindDefault(),
	collections: [],
	images: [],
	imageThumbnailId: 0,
	keywords: [],
	materials: [],
	sizes: [],
	tags: [],
	items: 0
});

export const getItemPrototypeAdaptedDefault = (): ItemPrototypeAdapted => ({
	id: 0,
	name: {
		imageId: 0,
		name: ""
	},
	description: "",
	isActive: COMMON_STATUS.ACTIVE,
	createdAt: new Date().toLocaleString(),
	updatedAt: new Date().toLocaleString(),
	feature: getItemPrototypeFeatureDefault(),
	translations: [],
	kind: getKindDefault(),
	collections: [],
	images: [],
	imageThumbnailId: 0,
	keywords: [],
	materials: [],
	sizes: [],
	tags: [],
	items: 0
});
